import { graphql } from "react-relay";

export const QUERY = graphql`
	query offerCatalogue_Query($first: Int, $text: String, $tagIds: [ID!]!) {
		Admin {
			Offer {
				subscribableOffers(first: $first, text: $text, tagIds: $tagIds) {
					edges {
						node {
							offerId
							owner
							title
							latestVersion
							alreadySubscribed
							compatibility {
								isCompatible
								missingElementTypes
							}
						}
					}
				}
			}
		}
	}
`;
